import React, { useEffect, useState } from "react";
import NoDataFound from "../../../../Extra/NoDataFound";
import GroupedBarChart from "../../../../CHARTS/GroupedBarChart";
import axios from "axios";
import AdrmGraphMaster from "./Graph/AdrmGraphMaster";

const AdrmDailyBlockPositionGraph = ({ dates, fetchBtnClick }) => {
  // console.log(fetchBtnClick);
  const [adrmData, setAdrmData] = useState(null);
  const [chartDataTRD, setChartDataTRD] = useState(null);
  const [chartDataSNT, setChartDataSNT] = useState(null);
  const [chartDataEngg, setChartDataEngg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;

  const fetchedData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}getADRM_CURR_PRE_YR_DATA?start=${dates.startDate}&end=${dates.endDate}`
      );

      if (response.data.status === "ok") {
        setAdrmData(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    fetchedData();
  }, [fetchBtnClick]);
  function getChartDataByDept(dept) {
    // Extract unique years from block_date
    const years = [
      ...new Set([
        ...adrmData?.previousData.map((item) =>
          new Date(item.block_date).getFullYear()
        ),
        ...adrmData.currentData.map((item) =>
          new Date(item.block_date).getFullYear()
        ),
      ]),
    ].sort(); // Sort to ensure previous year comes first

    // Filter data by department
    const currentDeptData = adrmData?.currentData.filter(
      (item) => item.dept === dept
    );
    const previousDeptData = adrmData?.previousData.filter(
      (item) => item.dept === dept
    );

    // Initialize result object
    const chartData = {
      dimensions: ["product", ...years.map(String)], // Dynamically set years
      series: [
        { product: "blocks_agreed" },
        { product: "hours_agreed" },
        { product: "blocks_granted" },
        { product: "hours_granted" },
      ],
    };

    // Calculate sums for each year
    chartData.series.forEach((seriesItem) => {
      years.forEach((year) => {
        const yearData =
          year === new Date(adrmData?.previousData[0]?.block_date).getFullYear()
            ? previousDeptData
            : currentDeptData;
        const originalKey = `total_corridor_${seriesItem.product}`; // Map back to original data key
        const total = yearData
          .filter((item) => new Date(item.block_date).getFullYear() === year)
          .reduce((sum, item) => sum + (item[originalKey] || 0), 0);

        seriesItem[String(year)] =
          seriesItem.product === "hours_agreed" ||
          seriesItem.product === "hours_granted"
            ? (total / 3600).toFixed(0)
            : total;
      });
    });

    return chartData;
  }
  useEffect(() => {
    if (adrmData && adrmData?.currentData?.length > 0) {
      const formattedData = getChartDataByDept("TRD");
      setChartDataTRD(formattedData);
      const formattedDataSnT = getChartDataByDept("S&T");
      setChartDataSNT(formattedDataSnT);
      const formattedDataEngg = getChartDataByDept("ENGG");
      setChartDataEngg(formattedDataEngg);
    }
  }, [adrmData]);
  return (
    <div className="papaDiv">
      <div className="row ">
        <div className="col-md-4 ">
          <div className="m-1 papaDiv">
            <h5 className="bg-dark text-white"> ENGINEERING </h5>
            {chartDataEngg && chartDataEngg.series.length > 0 ? (
              <GroupedBarChart
                data={chartDataEngg}
                height={200}
                from={`Block_C`}
                rotateText={10}
                chartType="bar"
              />
            ) : (
              <NoDataFound />
            )}
          </div>
        </div>
        <div className="col-md-4  ">
          <div className="m-1 papaDiv">
            <h5 className="bg-dark text-white"> TRD </h5>
            {chartDataTRD && chartDataTRD.series.length > 0 ? (
              <GroupedBarChart
                data={chartDataTRD}
                height={200}
                from={`Block_C`}
                rotateText={10}
                chartType="bar"
              />
            ) : (
              <NoDataFound />
            )}
          </div>
        </div>
        <div className="col-md-4 ">
          <div className="m-1 papaDiv">
            <h5 className="bg-dark text-white"> S&T </h5>
            {chartDataSNT && chartDataSNT.series.length > 0 ? (
              <GroupedBarChart
                data={chartDataSNT}
                height={200}
                from={`Block_C`}
                rotateText={10}
                chartType="bar"
              />
            ) : (
              <NoDataFound />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default AdrmDailyBlockPositionGraph;
